import * as React from "react";
import AuthService from "../../Components/auth/AuthService";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import { useLoadingDispatch, showLoading, hideLoading } from '../../context/loadingContext';
import { locationCategories } from "../../Components/common/Constants";
import { Button, Row, Col, Input, Select, Table, Modal, Divider, Flex, Checkbox, Tag } from "antd";
import { useSelector } from "react-redux";
import { ApartmentOutlined, CodeOutlined, NumberOutlined, PicCenterOutlined, PlusOutlined, TagsOutlined, ProductOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { showMessage } from "../../Components/Utils/message";
import FormGrid from "../../Components/common/FormGrid";
import { decodeId } from "../../Components/common/CommonFun";

const Auth = new AuthService();

export default function Location(props) {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
    const decodedID = decodeId(params?.id)

  const { Option } = Select
  var layoutDispatch = useLoadingDispatch();
  const { products, aisles, roles, type: roleType } = useSelector((state) => state?.AppState?.userCreds);
  const canAccess =
    roleType === 0 ||
    roleType === 1 ||
    (roleType === 2 && roles?.some((role) => role.role_id === 4));

  const [id, setId] = React.useState(decodedID ? decodedID : 0);
  // const [allAisles, setAllAisles] = React.useState([]);
  const [locationProducts, setLocationProducts] = React.useState([]);
  const [allLocationProducts, setAllLocationProducts] = React.useState([]);
  const [addProductModalOpen, setAddProductModalOpen] = React.useState(false);
  const [newProductDetail, setNewProductDetail] = React.useState({
    location_id: id,
    product_id: null,
    location_type: null,
    aisle: null,
    is_picking: false,
    is_binning: false,
  });
  const [locationDetails, setLocationDetails] = React.useState({
    code: '',
    title: '',
    aisle: null,
    location_type: null,
    transit: false,
    pallet_capacity: '',
    width: '',
    height: '',
    products: null,
    category: null,
    is_picking: false,
    is_binning: false,
  });

  const getLocationProducts = async () => {
    showLoading(layoutDispatch)
    try {
      const res = await Auth.fetch(`/product-location/product-stock-by-location?id=${id}`)
      if (res?.ack) {
        console.log(res);
        setLocationProducts(res?.product_location)
      } else {
        showMessage('error', res?.message)
      }
    } catch (err) {
      console.log(err);
      showMessage('error', 'Something went wrong');

    } finally {
      hideLoading(layoutDispatch)
    }
  };

  const getAllLocationProducts = async () => {
    showLoading(layoutDispatch)
    try {
      const res = await Auth.fetch(`/location/location-products?id=${id}`)
      if (res?.ack) {
        console.log(res);
        setAllLocationProducts(res?.product_picking_locations)
      } else {
        showMessage('error', res?.message)
      }
    } catch (err) {
      console.log(err);
      showMessage('error', 'Something went wrong');

    } finally {
      hideLoading(layoutDispatch)
    }
  };

  React.useEffect(() => {
    if (id > 0) {
      getLocationProducts()
      getAllLocationProducts()
    }
  }, [id])



  React.useEffect(() => {
    if (id > 0) {
      showLoading(layoutDispatch);
      Auth.fetch(`/location/location?id=${id}`)
        .then((res) => {
          hideLoading(layoutDispatch);
          if (res.ack) {
            setLocationDetails({
              ...locationDetails,
              code: res?.location?.code,
              title: res?.location?.title,
              aisle: res?.location?.aisle_id,
              location_type: res?.location?.type,
              pallet_capacity: res?.location?.pallet_capacity,
              width: res?.location?.width,
              height: res?.location?.height,
              transit: res?.location?.is_transit === 1 ? true : false,
              is_picking: res?.location?.is_picking === 1 ? true : false,
              is_binning: res?.location?.is_binning === 1 ? true : false,
              // category: res?.location?.category_type,

            })
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }


  }, []);

  const onClickCancel = () => {
    navigate("/locations");
  };

  const getAllLocs = async () => {
    showLoading(layoutDispatch)
    try {

      const res = await Auth.fetch(`/location/locations`);
      if (res.ack) {
        // setAllLocations(res?.locations)
        if (res?.locations.length > 0) {
          const newTimestamp = new Date().getTime();
          dispatch({
            type: 'SET_LOCATIONS',
            payload: { locations: res?.locations, timestamp: newTimestamp },
          });
        }
        // showMessage('success',res.message);
      } else {
        showMessage('error', res.message);
      }
    } catch (error) {
      console.log(error);
      showMessage('error', "Something went wrong");
    } finally {
      hideLoading(layoutDispatch)
    }
  };

  const handleSubmit = async () => {

    const isEmptyOrUndefined = (value) => value === '' || value === null || value === undefined;
    const validations = [
      { key: 'title', message: 'Please add title' },
      { key: 'aisle', message: 'Please add aisle' },
      // { key: 'category', message: 'Please add category' },
      { key: 'location_type', message: 'Please add location type' },
      { key: 'pallet_capacity', message: 'Please add pallet capacity' },
      { key: 'width', message: 'Please add width' },
      { key: 'height', message: 'Please add height' },
    ];

    for (const { key, message: errorMessage } of validations) {
      if (isEmptyOrUndefined(locationDetails?.[key])) {
        showMessage('error', errorMessage);
        return;
      }
    }
    const atLeastOneSelected =
      locationDetails.transit || locationDetails.is_picking || locationDetails.is_binning;

      if (!atLeastOneSelected) {
        showMessage('error', 'Please select at least one storage type!');
        return;
      }
    showLoading(layoutDispatch);
    const isUpdate = id > 0;
    const dataToSend = {
      id: isUpdate ? id : undefined,
      title: locationDetails.title,
      code: locationDetails.code,
      type: locationDetails.location_type,
      aisle_id: locationDetails.aisle,
      pallet_capacity: locationDetails.pallet_capacity,
      height: locationDetails.height,
      width: locationDetails.width,
      is_transit: locationDetails.transit ? 1 : 0,
      is_picking: locationDetails.is_picking ? 1 : 0,
      is_binning: locationDetails.is_binning ? 1 : 0,
      // category_type: locationDetails.category,
    }
    try {
      const method = isUpdate ? "PUT" : "POST";
      const res = await Auth.fetch("/location/location", {
        method: method,
        body: JSON.stringify(dataToSend),
      })
      if (res?.ack) {
        
        getAllLocs();
        showMessage('success', res?.message)
        navigate('/locations')
      } else {
        showMessage('error', res?.message)
      }

    } catch (err) {
      console.log(err);
    }
    finally {
      hideLoading(layoutDispatch);
    }
  };

  const locationProductsCol = [

    // {
    //   title: 'Location',
    //   render: (record) => {
    //     const selected = locations?.find((item) => item.id == record?.location_id)
    //     return (
    //       <>
    //         {selected?.code}
    //       </>
    //     );
    //   }
    // },
    //  {
    //   title: 'Location Category',
    //   render: (record) => {
    //     const selected = locationCategories?.find((item) => item.netsuite_id == record?.location_type)
    //     return (
    //       <>
    //         {`${selected?.title}`}
    //       </>
    //     );
    //   }
    // },
    {
      title: 'Product',
      render: (record) => {
        const selected = products?.find((item) => item.netsuite_id == record?.product_netsuite_id)
        return (
          <>
            {`${selected?.code} - ${selected?.name}`}
          </>
        );
      }
    },
    // {
    //   title: 'Product Category',
    //   render: (record) => {
    //     const selected = products?.find((item) => item.netsuite_id == record?.product_netsuite_id)
    //     return (
    //       <>
    //         {`${selected?.category}`}
    //       </>
    //     );
    //   }
    // },
    {
      title: 'Product Category',
      render: (record) => {
        const selected = products?.find((item) => item.netsuite_id == record?.product_netsuite_id)
        return (
          <>
            {`${selected?.sub_category}`}
          </>
        );
      }
    },
    // {
    //   title: 'Aisle',
    //   render: (record) => {
    //     const selected = aisles?.find((item) => item.id == record?.aisle_id)
    //     return (
    //       <>
    //         { selected?.title ? `${selected?.title} ` : ''}
    //       </>
    //     );
    //   }
    // },
    // {
    //   title: 'Location Type',
    //   render: (record) => {
    //     const selected = locationCategories?.find((item) => item.id == record?.type)
    //     return (
    //       <>
    //         {`${selected?.title ? selected?.title : ''} `}
    //       </>
    //     );
    //   }
    // },
    {
      title: 'Stock',
      render: (record) => {
        return (
          <>
          <Tag color='green' style={{ fontSize: 16, fontWeight: 'bold' }}>{Number(record?.stock_level).toLocaleString(undefined, {
            maximumFractionDigits: 2,
          })} </Tag>

          </>
        )
      }
    },
    // {
    //   title: 'Action',
    //   key: 'action',
    //   align: "right",
    //   dataIndex: '',
    //   render(record) {
    //     return (
    //       <div >

    //         <DeleteFilled style={
    //               {
    //                 fontSize: "25px",
    //                 cursor: "pointer",
    //                 color: "#cd1437",
    //             }} onClick={() => {
    //               Modal.confirm({
    //                 title: 'Delete Location',
    //                 centered: true,
    //                 content: `Are you sure you want to delete this location?`,
    //                 onOk:()=> deleteLocation(record.id),
    //                 okText: 'Delete',
    //                 cancelText: 'Cancel',
    //                 width: 600,
    //                 okButtonProps: { size: "large"  },
    //                 cancelButtonProps: { size: "large" },
    //               });
    //             }} 
    //             />
    //       </div>
    //     );
    //   },
    // },

  ];

  const allLocationProductsCol = [

    {
      title: 'Product',
      render: (record) => {
        const selected = products?.find((item) => item.netsuite_id == record?.product_netsuite_id)
        return (
          <>
            {`${selected?.code} - ${selected?.name}`}
          </>
        );
      }
    },
    {
      title: 'Product Category',
      render: (record) => {
        const selected = products?.find((item) => item.netsuite_id == record?.product_netsuite_id)
        return (
          <>
            {`${selected?.sub_category}`}
          </>
        );
      }
    },
    

  ];

  const deleteLocation = async (id) => {
    showLoading(layoutDispatch);
    try {
      const res = await Auth.fetch(`/product-location/product-location`, {
        method: "DELETE",
        body: JSON.stringify({ id: id })

      });
      if (res?.ack) {
        getLocationProducts();
        showMessage('success', res?.message);
      } else {
        showMessage('error', res?.message);
      }
    } catch (err) {
      console.log(err);
      showMessage('error', err?.message);
    } finally {
      hideLoading(layoutDispatch);
    }
  };

  const handleModalCancel = () => {
    setAddProductModalOpen(false);
  };



  const handleOk = async () => {

    const isEmptyOrUndefined = (value) => value === '' || value === null || value === undefined;
    const validations = [
      { key: 'product_id', message: 'Please add product' },
      // { key: 'location_type', message: 'Please add location type' },
      // { key: 'aisle', message: 'Please add aisle' },

    ];

    for (const { key, message: errorMessage } of validations) {
      if (isEmptyOrUndefined(newProductDetail?.[key])) {
        showMessage('error', errorMessage);
        return;
      }
    };

    showLoading(layoutDispatch);
    const dataToSend = {
      // type: newProductDetail.location_type,
      location_id: id,
      product_netsuite_id: newProductDetail.product_id,
      aisle_id: locationDetails?.aisle,
      is_binning: 0,
      is_picking: 1,

    }
    try {
      const res = await Auth.fetch("/product-location/product-location", {
        method: 'POST',
        body: JSON.stringify(dataToSend),
      })
      if (res?.ack) {
        showMessage('success', res?.message)
        setAddProductModalOpen(false)
        getLocationProducts();
        getAllLocationProducts();
        getAllLocs();
      } else {
        showMessage('error', res?.message)
      }

    } catch (err) {
      console.log(err);
      showMessage('error', 'something went wrong')
    }
    finally {
      hideLoading(layoutDispatch);
    }
  };

  const modalFormItem =[
    {
      label: "Product",
      value: newProductDetail?.product_id,
      options: products,
      onChange: (val) => setNewProductDetail({ ...newProductDetail, product_id: val }),
      icon: <ProductOutlined style={{ color: "#1677ff"}}/>,
      readOnly: false,
      type: 'select',
      data: 'products',
    },
  ]

  const formItems = [
    {
      label: "Code",
      value: locationDetails?.code,
      onChange: (val) => setLocationDetails({ ...locationDetails, code: val }),
      readOnly: id > 0,
      icon: <CodeOutlined />,
      type: 'text'
    },
    {
      label: "Title",
      value: locationDetails?.title,
      onChange: (val) => setLocationDetails({ ...locationDetails, title: val }),
      icon: <TagsOutlined  style={{ color: "#1677ff"}}/>,
      readOnly: false,
      type: 'text'

    },
    {
      label: "Aisle",
      value: locationDetails?.aisle,
      options: aisles,
      onChange: (val) => setLocationDetails({ ...locationDetails, aisle: val }),
      icon: <PicCenterOutlined style={{ color: "#13c2c2"}}/>,
      readOnly: id > 0,
      type: 'select',
      data: 'constants'
    },
    {
      label: "Location Type",
      value: locationDetails?.location_type,
      options: locationCategories,
      onChange: (val) => setLocationDetails({ ...locationDetails, location_type: val }),
      icon: <ApartmentOutlined  style={{ color: "#722ed1"}}/>,
      readOnly: id > 0,
      type: 'select',
      data: 'constants'
    },
    {
      label: "Pallet Capacity",
      value: locationDetails?.pallet_capacity,
      onChange: (val) => {
        if(val < 1) return showMessage('error', 'Pallet Capacity can not be negative!') 
        setLocationDetails({ ...locationDetails, pallet_capacity: val })
      },
      readOnly: false,
      icon: <NumberOutlined  style={{ color: "#52c41a"}}/>,
      type: 'number'
    },
    {
      label: "Width (CMs)",
      value: locationDetails?.width,
      onChange: (val) => {
        if(val < 1) return showMessage('error', 'Width can not be negative!') 
        setLocationDetails({ ...locationDetails, width: val })
      },
      readOnly: false,
      icon: <NumberOutlined  style={{ color: "#52c41a"}}/>,
      type: 'number'
    },
    {
      label: "Height (CMs)",
      value: locationDetails?.height,
      onChange: (val) => {
        if(val < 1) return showMessage('error', 'Height can not be negative!') 
        setLocationDetails({ ...locationDetails, height: val })
      },
      readOnly: false,
      icon: <NumberOutlined  style={{ color: "#52c41a"}}/>,
      type: 'number'
    },
    
  ]

  return (
    <>
      <h1 style={{ margin: 0}}> {id > 0 ? "Update" : "Add"} Location</h1>
      <FormGrid formItems={formItems} viewType='Page' />
      {/* <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <span>
            Code
          </span>
          <Input
            disabled={id > 0}
            value={locationDetails?.code}
            onChange={(e) => setLocationDetails({ ...locationDetails, code: e.target.value })}
            placeholder='Code'
          />
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <span>
            Title
          </span>
          <Input
            value={locationDetails?.title}
            onChange={(e) => setLocationDetails({ ...locationDetails, title: e.target.value })}
            placeholder='Title'
          />
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <span>
            Aisle<span style={{ color: "red" }}>*</span>
          </span>
          <Select
            style={{
              width: "100%",
            }}
            showSearch
            allowClear
            disabled={id > 0}
            value={locationDetails.aisle}
            placeholder="Aisle"
            filterOption={(input, option) =>
              option?.children?.toLowerCase().includes(input.toLowerCase())
            }
            onChange={(value) => setLocationDetails({ ...locationDetails, aisle: value })}
          >
            {aisles?.map((item) => (
              <Option key={item?.id} value={item?.id}>
                {item?.title}
              </Option>
            ))}
          </Select>
        </Col>
       
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <span>
            Location Type<span style={{ color: "red" }}>*</span>
          </span>
          <Select
            style={{
              width: "100%",
            }}
            showSearch
            allowClear
            disabled={id > 0}
            value={locationDetails.location_type}
            placeholder="Aisle"
            filterOption={(input, option) =>
              option?.children?.toLowerCase().includes(input.toLowerCase())
            }
            onChange={(value) => setLocationDetails({ ...locationDetails, location_type: value })}
          >
            {locationCategories?.map((item) => (
              <Option key={item?.id} value={item?.id}>
                {item?.title}
              </Option>
            ))}
          </Select>
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <span>
            Pallet Capacity
          </span>
          <Input
            value={locationDetails?.pallet_capacity}
            onChange={(e) => setLocationDetails({ ...locationDetails, pallet_capacity: e.target.value })}
            placeholder='Pallet Capacity'
          />
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <span>
            {`Width (CMs)`}
          </span>
          <Input
            value={locationDetails?.width}
            onChange={(e) => setLocationDetails({ ...locationDetails, width: e.target.value })}
            placeholder='Width'
          />
        </Col>
        <Col xs={24} sm={12} md={8} lg={8} xl={8}>
          <span>
            {`Height (CMs)`}

          </span>
          <Input
            value={locationDetails?.height}
            onChange={(e) => setLocationDetails({ ...locationDetails, height: e.target.value })}
            placeholder='Height'
          />
        </Col>

      </Row> */}

      <div style={{ marginTop: "20px", padding: "16px", border: "1px solid #f0f0f0", borderRadius: "8px" }}>
      <h3 style={{ marginBottom: "12px", margin: 0 }}>Storage Types</h3>
            <Row style={{ marginTop: 15, marginLeft: 1 }} gutter={[16, 16]}>

        <Col xs={24} sm={12} md={4} lg={4} xl={4}>
         
          <Checkbox
            style={{ transform: "scale(1.2)" }}
            checked={locationDetails.is_picking}
            onChange={(e) => {
              const isChecked = e.target.checked;
              if (isChecked) {
                Modal.confirm({
                  title: "Are you sure?",
                  content: "Once Checked, this cannot be changed later.",
                  okText: "Yes",
                  cancelText: "No",
                  centered: true,
                  onOk: () => {
                    setLocationDetails({ ...locationDetails, is_picking: true });
                  },
                  onCancel: () => {
                  },
                });
              } else {
                setLocationDetails({ ...locationDetails, is_picking: false });
              }
            }}
            disabled={id > 0 && locationDetails.is_picking == 1}
          >
            Picking
          </Checkbox>

        </Col>

        <Col xs={24} sm={12} md={4} lg={4} xl={4}>
          <Checkbox
            style={{ transform: "scale(1.2)" }}

            checked={locationDetails.is_binning}
            onChange={(e) =>
              setLocationDetails({ ...locationDetails, is_binning: e.target.checked })
            }
          >
            Binning
          </Checkbox>
        </Col>
        <Col xs={24} sm={12} md={4} lg={4} xl={4}>
          <Checkbox
            style={{ transform: "scale(1.2)" }}
            checked={locationDetails.transit}
            onChange={(e) =>
              setLocationDetails({ ...locationDetails, transit: e.target.checked })
            }
          >
            Transit
          </Checkbox>
        </Col>

      </Row>
  </div>

      <Flex justify="end" style={{ marginTop: "40px" }}>
        <Button
          style={{ marginRight: "10px" }}
          onClick={onClickCancel}
        >
          Cancel
        </Button>
        {
          canAccess && (
            <Button type="primary" onClick={handleSubmit}>
              Save
            </Button>
          )
        }
      </Flex>

      {id > 0 && (
        <>
        <div className="detail-box" style={{ marginTop: '30px' }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'center' }}>
            <span className="detail-box-heading">
              Picking List
            </span>
            {canAccess && (
              <Button
                onClick={() => {
                  setAddProductModalOpen(true)
                }}
                type="primary" icon={<PlusOutlined />}>Add Product</Button>
            )}

          </div>

          <Table dataSource={allLocationProducts} columns={allLocationProductsCol} style={{ marginTop: "4px" }} pagination={false} rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")} scroll={{ x:'max-content'}}/>

        </div>
        <div className="detail-box" style={{ marginTop: '30px' }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'center' }}>
            <span className="detail-box-heading">
              Stock List
            </span>
          </div>
          <Table dataSource={locationProducts} columns={locationProductsCol} style={{ marginTop: "4px" }} pagination={false} rowClassName={(_, index) => (index % 2 === 1 ? "table-row-striped" : "")} scroll={{ x:'max-content'}}/>
        </div>
        </>
      )}
      <Modal width={600} title={<>
        <span style={{ fontWeight: 200 }} >{`Add Product for `}
        </span>
        <span >
          {`${locationDetails?.code} - ${locationDetails?.title}`}
        </span>
      </>} open={addProductModalOpen} onOk={handleOk} onCancel={handleModalCancel} okText="Save">
        <Divider style={{ margin: '10px 0px' }} />
        {/* <Row>
          <Col xs={24} sm={12} md={12} lg={12} xl={12}>
            <span>
              Product<span style={{ color: "red" }}>*</span>
            </span>
            <Select
              style={{
                width: "100%",
              }}
              showSearch
              allowClear
              value={newProductDetail.product_id}
              placeholder="Product"
              filterOption={(input, option) =>
                option?.children?.toLowerCase().includes(input.toLowerCase())
              }
              onChange={(value) => setNewProductDetail({ ...newProductDetail, product_id: value })}
            >
              {products?.map((item) => (
                <Option key={item?.netsuite_id} value={item?.netsuite_id}>
                  {` ${item?.code} - ${item?.name} `}
                </Option>
              ))}
            </Select>

          </Col>

        </Row> */}
        <FormGrid formItems={modalFormItem} viewType='Modal' />
      </Modal>
    </>
  );
}
